import React, { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient";
import LoaderBox from "../HomePage/LoaderBox";

const KonobarInventoryEdit = ({ onBack }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);

  // State za formu
  const [formData, setFormData] = useState({
    name: "",
    total_stock: "",
    price: "",
    category: "sok",
  });

  useEffect(() => {
    fetchInventory();
  }, []);

  const fetchInventory = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from("inventory")
      .select("*")
      .order("name", { ascending: true });

    if (error) {
      console.error("Greška:", error.message);
    } else {
      setItems(data || []);
    }
    setLoading(false);
  };

  // Otvaranje modala za NOVI artikl
  const openAddModal = () => {
    setEditingId(null);
    setFormData({ name: "", total_stock: 0, price: 0, category: "sok" });
    setIsModalOpen(true);
  };

  // Otvaranje modala za UREĐIVANJE postojećeg artikla
  const openEditModal = (item) => {
    setEditingId(item.id);
    setFormData({
      name: item.name,
      // U polje upisujemo TRENUTNO STANJE (npr. 0 ako je sve prodano)
      total_stock: item.total_stock - item.sold_count,
      price: item.price,
      category: item.category || "sok",
    });
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setEditingId(null);
  };

  const handleSaveItem = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Pripremi podatke za slanje (pretvori prazne stringove u 0)
    const finalData = {
      ...formData,
      total_stock: Number(formData.total_stock) || 0,
      price: Number(formData.price) || 0,
    };

    try {
      if (editingId) {
        const currentItem = items.find((i) => i.id === editingId);
        const vecProdano = currentItem ? currentItem.sold_count : 0;

        // Izračun novog totala na temelju onoga što je upisano kao "novo stanje"
        const noviTotal = finalData.total_stock + vecProdano;

        const { error } = await supabase
          .from("inventory")
          .update({
            ...finalData,
            total_stock: noviTotal,
          })
          .eq("id", editingId);

        if (error) throw error;
      } else {
        const { error } = await supabase.from("inventory").insert([finalData]);
        if (error) throw error;
      }

      closeModal();
      await fetchInventory();
    } catch (err) {
      alert("Greška: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  const deleteItem = async (id) => {
    if (window.confirm("Sigurno želiš obrisati ovaj proizvod?")) {
      const { error } = await supabase.from("inventory").delete().eq("id", id);
      if (error) alert("Greška pri brisanju!");
      fetchInventory();
    }
  };

  return (
    <div className="inventory-edit-wrapper">
      <div className="inventory-header">
        <button className="back-btn-minimal" onClick={onBack}>
          <i className="fi fi-rs-arrow-left"></i> Idi natrag
        </button>
        <h2>Upravljanje Artiklima</h2>
        <button className="add-btn" onClick={openAddModal}>
          <i className="fi fi-rs-plus"></i> Dodaj Novi artikal
        </button>
      </div>

      {loading && !isModalOpen ? (
        <>
          {" "}
          <LoaderBox text="Učitavanje podataka..." />
        </>
      ) : (
        <div className="items-table-container">
          <table className="items-table">
            <thead>
              <tr>
                <th>Naziv</th>
                <th>Zaliha</th>
                <th>Cijena</th>
                <th>Akcija</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.id}>
                  <td>{item.name}</td>
                  <td
                    style={{
                      fontWeight: "bold",
                      color:
                        item.total_stock - item.sold_count <= 5
                          ? "#ff9800"
                          : "white",
                    }}
                  >
                    {item.total_stock - item.sold_count} kom
                  </td>
                  <td>{item.price.toFixed(2)}€</td>
                  <td className="actions-cell">
                    <button
                      className="edit-icon-btn"
                      onClick={() => openEditModal(item)}
                    >
                      <i className="fi fi-rs-edit"></i>
                    </button>
                    <button
                      className="delete-icon-btn"
                      onClick={() => deleteItem(item.id)}
                    >
                      <i className="fi fi-rs-trash"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* MODAL ZA DODAVANJE / UREĐIVANJE */}
      {isModalOpen && (
        <div
          className="modal-overlay"
          onClick={(e) => {
            if (e.target.className === "modal-overlay") closeModal();
          }}
        >
          <div className="modal-content">
            <h3>{editingId ? "Uredi Proizvod" : "Novi Proizvod"}</h3>
            <form onSubmit={handleSaveItem}>
              <div className="input-group">
                <label>Naziv proizvoda</label>
                <input
                  type="text"
                  required
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  placeholder="npr. Pivo 0.5l"
                />
              </div>

              <div className="input-group">
                <label>Kategorija</label>
                <select
                  value={formData.category}
                  onChange={(e) =>
                    setFormData({ ...formData, category: e.target.value })
                  }
                  className="custom-select"
                >
                  <option value="sok">Sok</option>
                  <option value="pivo">Pivo</option>
                  <option value="voda">Voda</option>
                  <option value="vino">Vino</option>
                  <option value="zestica">Žestica</option>
                  <option value="kava">Kava / Topli napitci</option>
                </select>
              </div>

              <div className="input-row">
                <div className="input-group">
                  <label>Zaliha</label>
                  <input
                    type="number"
                    required
                    // Ako je vrijednost 0, dopusti da bude prazan string radi lakšeg brisanja
                    value={
                      formData.total_stock === 0 ? "" : formData.total_stock
                    }
                    onChange={(e) => {
                      const val = e.target.value;
                      // Ako je polje prazno, stavi prazan string, inače pretvori u broj
                      setFormData({
                        ...formData,
                        total_stock: val === "" ? "" : parseInt(val),
                      });
                    }}
                    placeholder="0"
                  />
                </div>
                <div className="input-group">
                  <label>Cijena (€)</label>
                  <input
                    type="number"
                    step="0.1"
                    required
                    value={formData.price === 0 ? "" : formData.price}
                    onChange={(e) => {
                      const val = e.target.value;
                      setFormData({
                        ...formData,
                        price: val === "" ? "" : parseFloat(val),
                      });
                    }}
                    placeholder="0.00"
                  />
                </div>
              </div>

              <div className="modal-actions">
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={closeModal}
                >
                  Odustani
                </button>
                <button type="submit" className="save-btn">
                  {editingId ? "Spremi Izmjene" : "Dodaj Artikl"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default KonobarInventoryEdit;
